import { useState, useEffect } from 'react';
import { API } from './index';

// App列表Hook
const useAppList = () => {
  const [appList, setAppList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadAppList = async () => {
    setLoading(true);
    setError(null);
    
    // 由于用户端App API已移除，直接使用mock数据
    // 在实际使用中，App信息会通过执行API自动处理
    setAppList([
      { key: 'a1b2c3d4e5f6g7h8', text: 'Google Chrome', value: 'a1b2c3d4e5f6g7h8', bundle_id: 'com.google.Chrome' },
      { key: 'b2c3d4e5f6g7h8i9', text: 'Visual Studio Code', value: 'b2c3d4e5f6g7h8i9', bundle_id: 'com.microsoft.VSCode' },
      { key: 'c3d4e5f6g7h8i9j0', text: '访达', value: 'c3d4e5f6g7h8i9j0', bundle_id: 'com.apple.finder' },
      { key: 'd4e5f6g7h8i9j0k1', text: 'PyCharm', value: 'd4e5f6g7h8i9j0k1', bundle_id: 'com.jetbrains.pycharm' },
      { key: 'e5f6g7h8i9j0k1l2', text: 'Xcode', value: 'e5f6g7h8i9j0k1l2', bundle_id: 'com.apple.dt.Xcode' }
    ]);
    
    setLoading(false);
  };

  useEffect(() => {
    loadAppList();
  }, []);

  // 根据ID查找App信息
  const findAppById = (id) => {
    return appList.find(app => app.value === id);
  };

  // 获取App显示名称
  const getAppDisplayName = (id) => {
    const app = findAppById(id);
    return app ? app.text : `App ${id}`;
  };

  // 获取单个App名称（新的统一API使用）
  const getAppName = (appId) => {
    if (!appId) return '未知App';
    const app = appList.find(app => app.value === appId || app.key === appId);
    return app ? app.text : `App ${appId}`;
  };

  // 根据多个ID获取App名称列表
  const getAppNames = (ids) => {
    if (!ids || ids.length === 0) return [];
    return ids.map(id => getAppDisplayName(id));
  };

  // 转换为Select组件的options格式
  const getAppOptions = () => {
    return appList;
  };

  // 搜索App（使用本地mock数据）
  const searchApps = async (keyword, limit = 10) => {
    // 由于用户端App API已移除，使用本地搜索
    const filteredApps = appList.filter(app => 
      app.text.toLowerCase().includes(keyword.toLowerCase()) ||
      app.bundle_id.toLowerCase().includes(keyword.toLowerCase())
    ).slice(0, limit);
    
    return filteredApps;
  };

  return {
    appList,
    loading,
    error,
    loadAppList,
    findAppById,
    getAppDisplayName,
    getAppName,
    getAppNames,
    getAppOptions,
    searchApps
  };
};

export default useAppList;
